<template lang="pug">
.flex.flex-col.items-center.font-bold.leading-none.cursor-pointer(
  :class='classObj'
)
  span Act
  span Circular
  span Now
</template>
<script>
export default {
  name: 'Logo',
  props: {
    small: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  computed: {
    classObj() {
      return this.small
        ? ['text-xl', 'sm_text-3xl']
        : ['text-3xl', 'sm_text-5xl']
    },
  },
}
</script>
